import { PlanApi } from "../api/home";
import { IFetcherOptions, useFetcher } from "@module/_core/infras/hook/useFetcher";
import { PlanDTO } from "../dto/home";

export class HomeService {
    static PLAN_KEY = "PLANS";
    static CHECKOUT_PLAN_KEY = "CHECKOUT_PLAN";

    static usePlans = ({ fetcherOptions }: { fetcherOptions?: IFetcherOptions<PlanDTO[]> }) => {
        const { data, isPending, isFetching, isError, error } = useFetcher(
            [HomeService.PLAN_KEY],
            () => PlanApi.getPlans(),
            fetcherOptions
        );

        return {
            data,
            isPending,
            isFetching,
            isError,
            error
        };
    };

    static useDetailPlan = ({
        planId,
        fetcherOptions
    }: {
        planId: number;
        fetcherOptions?: IFetcherOptions<{ plan: PlanDTO }>;
    }) => {
        const { data, isPending, isFetching, isError, error } = useFetcher(
            [HomeService.PLAN_KEY, planId],
            () => PlanApi.getDetailPlan(planId),
            fetcherOptions
        );

        return {
            data,
            isPending,
            isFetching,
            isError,
            error
        };
    };
}
